export default () => {
    setInterval(() => {
        postMessage({resignin: true});
    }, 5000);
};
